import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { pushRuntimeEvent, RT_EVENTS, getState } from "../../lib/kevia-runtime";

/**
 * KeviaActionChip — contextual navigation shortcut rendered below a Kevia response.
 *
 * @param {{ type: string, target: string, label: string, filter?: string }} action
 */
export const KeviaActionChip = React.memo(function KeviaActionChip({ action }) {
  const nav = useNavigate();

  const handleClick = () => {
    const dest = action.filter
      ? `${action.target}?kv_filter=${encodeURIComponent(action.filter)}`
      : action.target;

    pushRuntimeEvent({
      type:   RT_EVENTS.EXECUTE_ACTION_CHIP,
      module: getState().currentModule,
      metadata: { target: action.target, label: action.label },
    });

    nav(dest);
  };

  return (
    <button
      onClick={handleClick}
      className="
        inline-flex items-center gap-1
        px-2.5 py-[5px] rounded-full
        bg-[#1b4f9c]/[0.06] dark:bg-sky-500/[0.08]
        border border-[#1b4f9c]/[0.12] dark:border-sky-500/[0.15]
        text-[11px] text-[#1b4f9c]/80 dark:text-sky-400 font-medium
        transition-all duration-150 ease-out
        hover:bg-[#1b4f9c]/[0.10] dark:hover:bg-sky-500/[0.12]
        hover:text-[#1b4f9c] dark:hover:text-sky-300
        hover:border-[#1b4f9c]/[0.20] dark:hover:border-sky-500/[0.25]
        active:scale-[0.96]
        select-none
      "
    >
      <ArrowUpRight size={9} strokeWidth={2.5} />
      {action.label}
    </button>
  );
});
